import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

/**
 * Canonical amber no-show palette for full-size detail-panel buttons, so the
 * reservation detail and waitlist detail no-show controls read identically.
 * `hover:text-*` is pinned to neutralize the shadcn `outline` variant's
 * `hover:text-foreground` when this is layered onto a `<Button>`.
 */
export const NO_SHOW_DETAIL_CLASS =
  "border-[#b88a00] bg-[#fff2c4] text-[#8a6d00] hover:bg-[#fde9a8] hover:text-[#8a6d00]";

/**
 * Amber "No-show" action shared by the reservation and waitlist cards so the
 * two listings read identically. The amber palette is the canonical no-show
 * treatment; per-site layout (extra gap, different padding) comes via
 * `className` and is merged over the base by `cn`/tailwind-merge.
 */
export function NoShowButton({ className, children, ...props }: ComponentProps<"button">) {
  return (
    <button
      type="button"
      className={cn(
        "flex min-h-9 items-center justify-center rounded-lg border border-[#b88a00] bg-[#fff2c4] px-3 text-xs font-semibold disabled:opacity-40",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
